import { render, staticRenderFns } from "./ShopNewsCategory.vue?vue&type=template&id=44936e1a"
import script from "./ShopNewsCategory.vue?vue&type=script&lang=js"
export * from "./ShopNewsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports